// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PaymentCards_wrapper__RX6qT","title":"PaymentCards_title__rPZGc","dark":"PaymentCards_dark__pAecs","cards":"PaymentCards_cards__JH0lD"};